@if (situation(); as current) {
  <div class="ads-situation" data-testid="analysis-situation" [attr.data-kind]="current.kind">
    @if (isEffective()) {
      <span class="ads-situation__effective">
        <i class="pi pi-check-circle" aria-hidden="true"></i>{{ effectiveText() }}
      </span>
    } @else {
      @if (tag(); as currentTag) {
        <span class="ads-situation__tag" [ngClass]="'ads-situation__tag--' + currentTag.tone">
          {{ currentTag.label }}
        </span>
      }
      @if (messageParts().length > 0) {
        <!-- Tudo numa linha só, sem espaço entre os pedaços: quebra de linha no template vira espaço e separava o link
             da pontuação seguinte ("Balancete.xls . Este fica"). Os espaços certos já vêm dentro da própria frase. -->
        <p class="ads-situation__message">@for (part of messageParts(); track $index) {@if (part.isLink) {<a href="#" class="ads-situation__link" [title]="'Abrir ' + part.text" (click)="onCoveredClick($event)">{{ part.text }}</a>} @else {<span>{{ part.text }}</span>}}</p>
      }
      @if (isOnlyDocumentForYear()) {
        <div class="ads-situation__actions" (click)="$event.stopPropagation()">
          <app-button
            label="Conferir e validar"
            size="small"
            [fitContent]="true"
            [noMargin]="true"
            (sendClick)="onReview()" />
        </div>
      }
    }
  </div>
}
